import React from "react";
import { GiCheckMark } from "react-icons/gi";

/**
 * Stepper for Add Product modal.
 * @param {{ steps: { title: string; subtitle: string }[]; activeIndex: number; variant?: "vertical" | "horizontal" }} props
 */
export function AddProductStepper({
  steps,
  activeIndex,
  variant = "vertical",
}) {
  if (variant === "horizontal") {
    return (
      <nav
        className="flex items-stretch gap-1 overflow-x-auto px-3 py-3 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        aria-label="Product setup steps"
      >
        {steps.map((step, index) => {
          const isComplete = index < activeIndex;
          const isActive = index === activeIndex;

          return (
            <div
              key={step.title}
              className="flex min-w-0 flex-1 items-center gap-2 rounded-lg px-1 py-0.5"
              aria-current={isActive ? "step" : undefined}
            >
              {isComplete ? (
                <span
                  className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#027A48] text-white"
                  aria-hidden
                >
                  <GiCheckMark className="text-[12px]" />
                </span>
              ) : (
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-[12px] font-semibold ${
                    isActive
                      ? "bg-[#1A1918] text-white"
                      : "bg-[#F0EFF0] text-[#9B9895] border border-solid border-[#E5E4E2]"
                  }`}
                >
                  {index + 1}
                </span>
              )}
              <p
                className={`my-0 truncate text-[12px] font-bold leading-tight sm:text-[13px] ${
                  isActive || isComplete ? "text-[#1A1918]" : "text-[#9B9895]"
                }`}
              >
                {step.title}
              </p>
            </div>
          );
        })}
      </nav>
    );
  }

  return (
    <nav className="flex flex-col gap-2 p-3" aria-label="Product setup steps">
      {steps.map((step, index) => {
        const isComplete = index < activeIndex;
        const isActive = index === activeIndex;

        return (
          <div
            key={step.title}
            className={`rounded-xl px-3 py-3 transition-colors ${
              isActive ? "bg-white shadow-sm" : "bg-transparent"
            }`}
          >
            <div className="flex gap-3">
              <div className="shrink-0 pt-0.5">
                {isComplete ? (
                  <span
                    className="flex h-8 w-8 items-center justify-center rounded-full bg-[#027A48] text-white"
                    aria-hidden
                  >
                    <GiCheckMark className="text-[14px]" />
                  </span>
                ) : (
                  <span
                    className={`flex box-border h-8 w-8 items-center justify-center rounded-full text-[13px] font-semibold ${
                      isActive
                        ? "bg-[#1A1918] text-white"
                        : "bg-[#F0EFF0] text-[#9B9895] border border-solid border-[#E5E4E2]"
                    }`}
                  >
                    {index + 1}
                  </span>
                )}
              </div>
              <div className="min-w-0">
                <p
                  className={`my-0 text-[13px] font-[900] leading-tight ${
                    isActive || isComplete ? "text-[#1A1918]" : "text-[#626262]"
                  }`}
                >
                  {step.title}
                </p>
                <p className="my-0 mt-0.5 text-[11px] text-[#7A7A7A] leading-snug">
                  {step.subtitle}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </nav>
  );
}
